import {isSelfGifting} from "../Manager/gift";

const isReGiftOriginalInCart = (gift, cart) => {
    for (let i in cart) {
        const cartItem = cart[i];
        if (gift.id === cartItem.regift_gift_id) {
            return true;
        }
    }
    return false;
};

const showRedemptionsOptions = ({ gift, exchangeOptions, showRedemptionAccounts, giftRedemptionAccounts, paymentCard }) => {
    let showRedemptionsOptions = false;

    // If not linked to card, then it can be further redeemed
    if (!gift.linked_card_id || gift.linked_card_error) {
        showRedemptionsOptions = true;
    }

    // If egift, it cannot be further redeemed, then do not show
    if (gift.gift_type === 'egift') {
        return false;
    }

    // If used, it cannot be further redeemed, then do not show
    if (gift.status === 'used') {
        return false;
    }

    // If gift is not fetched yet, then do not show
    if (!gift.id) {
        return false;
    }

    // If viewer is sender, then the sender cannot redeem own gift, then do not show
    if (gift.viewer_is_sender) {
        return false;
    }

    // If not linked to card, then it can be further redeemed
    if (!gift.linked_card_id) {
        showRedemptionsOptions = true;
    }

    // If linked card error, then it needs to be resolved
    if (gift.linked_card_error) {
        showRedemptionsOptions = true;
    }

    return showRedemptionsOptions;
};

const getUsableRedemptionOptions = (gift, redemptionAccounts = []) => {
    const accounts = [];
    if (redemptionAccounts === null) { return accounts; }
    for (const [, redemptionAccount] of redemptionAccounts.entries()) {

        if (redemptionAccount.network === 'visa' && (gift.merchant_visa_enabled)) {
            accounts.push(redemptionAccount);
        }
        if (redemptionAccount.network === 'mastercard' && (gift.merchant_mastercard_enabled)) {
            accounts.push(redemptionAccount);
        }
        if (redemptionAccount.network === 'amex' && (gift.merchant_amex_enabled)) {
            accounts.push(redemptionAccount);
        }
    }
    return accounts;
};

const getGiftRedemptionState = ({gift, account, order, reminderSent = false}) => {

    const canUpdateBalance = gift.id && gift.gift_type === 'egift' && gift.status === 'active' && !isSelfGifting(gift);

    const canManageGift =
        gift.id
        && account
        && (
            (order && order.billing_account_type && gift.viewer_is_sender)
            ||
            (gift.linked_card_id && gift.viewer_is_recipient)
        )
        && !isSelfGifting(gift)
    ;

    const canViewEgiftCardButton = gift.id && gift.viewer_is_recipient && gift.gift_type === 'egift' && gift.status !== 'pending' && !isSelfGifting(gift);

    const showDeliveryFailedMessage = gift.id && gift.viewer_is_sender && gift.delivery_failed && !isSelfGifting(gift);

    const showEgiftProcessingMessage = gift.id && gift.gift_type === 'egift' && gift.status === 'pending' && !isSelfGifting(gift);

    const canShowRemainingBalance =
        gift.id
        &&
        (
            (gift.gift_type === 'egift' && gift.status === 'active') || (gift.gift_type !== 'egift')
        )
        && !(gift.date_exchanged && gift.replacement_exchange && gift.replacement_exchange.type)
        && (
                (gift.linked_card_id && !gift.linked_card_error) || (gift.is_link_incentive_available && gift.viewer_is_recipient)
        )
        && !isSelfGifting(gift)


        // && (gift.gift_type !== 'egift' && gift.remaining_balance !== gift.amount)
        // && !(!gift.linked_card_id || gift.linked_card_error)
    ;

    const showRedemptionOptions = gift.id && (!gift.linked_card_id || gift.linked_card_error) && gift.status !== 'used' && gift.viewer_is_recipient && gift.gift_type !== 'egift' && !isSelfGifting(gift);

    const canShowHistory =
        (
            gift.id
            && (
                (gift.viewer_is_recipient && gift.recipient_history.length > 0)
                || (gift.viewer_is_sender && gift.sender_history.length > 0)
            )
        )
    ;

    const canSendThankYa = gift.id && gift.viewer_is_recipient && gift.thank_ya_enabled && gift.gift_type !== 'egift' && !isSelfGifting(gift);

    const isMcVisa = gift.id && !gift.linked_card_id && (gift.merchant_visa_enabled || gift.merchant_mastercard_enabled);

    const canChangeRecipient = (
        gift.id
        && gift.viewer_is_sender
        && gift.can_change_recipient
        && gift.gift_type !== 'egift'
        && gift.date_sent === null
    );
    const canSendReminder =
        gift.can_send_reminder
        // && !gift.delivery_failed
        // && gift.viewer_is_sender
        // && gift.gift_type !== 'egift'
        // && gift.redemption_token_created
        // && gift.remaining_balance > 0
        // && !reminderSent
        // && !isSelfGifting(gift)
        // && !gift.is_regift_pending
    ;

    const canChangeDateSend = (
        gift.id
        && gift.viewer_is_sender
        && gift.can_change_date_send
        && gift.gift_type !== 'egift'
        && !gift.regift
    );

    const canReGift = gift.canReGift;

    return {
        isMcVisa: !!isMcVisa,
        canSendReminder: !!canSendReminder,
        canChangeRecipient: !!canChangeRecipient,
        canChangeDateSend: !!canChangeDateSend,
        canUpdateBalance: !!canUpdateBalance,
        canManageGift: !!canManageGift,
        canViewEgiftCardButton: !!canViewEgiftCardButton,
        showDeliveryFailedMessage: !!showDeliveryFailedMessage,
        showEgiftProcessingMessage: showEgiftProcessingMessage,
        canShowRemainingBalance: canShowRemainingBalance,
        showRedemptionOptions: !!showRedemptionOptions,
        canShowHistory: !!canShowHistory,
        canSendThankYa: !!canSendThankYa,
        canReGift: !!canReGift
    }
};

export { showRedemptionsOptions, getUsableRedemptionOptions, getGiftRedemptionState, isReGiftOriginalInCart };
